import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { BIN as BINType } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type BinProps = {
  bin: BINType | undefined
}

export function Bin(props: BinProps) {
  const { formatList } = useIntl()
  const { bin } = props

  if (!bin?.length) return null

  const processTooltip = () => formatList(bin ?? [])

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.bin.title} />
      </Tag>
    </Tooltip>
  )
}
